/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Search from "../../assets/images/icon-search.svg";
import Arrow from "../../assets/images/pagination_arrow.svg";
import { TableRowPlaceholder } from "../../components/TableRowPlaceholder/TableRowPlaceholder";
import { useAppSelector } from "../../hooks/hooks";
import { ALL, GroupAdmin } from "../../utils/Constants";
import { hasAnyGroupAdminRole, hasRole } from "../../utils/Helpers";
import { Roles } from "../../utils/Constants";
import {
  callRequest,
  cashLoanStages,
  exportCreditAPIData,
  filters,
  loanStages,
  paginationElemnts,
  exportData,
  LoanLookUpInfoData,
} from "./hook/ScreenHelper";
import Moment from "react-moment";
import { Accordion, AccordionTab } from "primereact/accordion";

export const Loans: React.FC = () => {
  const { t } = useTranslation();
  const { loading } = useAppSelector((state) => state.settings);
  const [page, setPage] = useState<number>(1);
  const [inputs, setInputs] = useState<filters>({ page });
  const initialFilter = {
    page,
    requestType: ALL,
    stage: ALL,
    loadAllDocuments: false,
  };
  const [filters, setFilters] = useState<filters>(initialFilter);
  const [data, setData] = useState<LoanLookUpInfoData>(null);

  const [timer, setTimer] = useState(null);
  const [isFirstPageLoad, setIsFirstPageLoad] = useState(true);
  const [isFromSearch, setIsFromSearch] = useState(false);

  const isAdmin = hasAnyGroupAdminRole([
    GroupAdmin.OPERATION_ADMIN,
    GroupAdmin.CUSTOMER_CARE_ADMIN,
  ]);

  const isDropdownDisabled = () => {
    return !(data && data?.loanLookups?.length > 0);
    // return isFirstPageLoad
    //   ? !isAdmin
    //   : isFromSearch && !isAdmin && !(data?.loanLookups?.length > 0);
  };

  const fileHeaders = [
    { label: t("inputs.loans.createdAt"), key: "createdAt" },
    { label: t("inputs.loans.customerName"), key: "customerName" },
    { label: t("inputs.loans.nationalId"), key: "nationalId" },
    { label: t("inputs.loans.financialDataId"), key: "financialDataId" },
    { label: t("inputs.loans.compAppId"), key: "compApplId" },
    { label: t("inputs.loans.lastCashLoanStage"), key: "lastCashLoanStage" },
    { label: t("inputs.loans.reason"), key: "reason" },
  ];

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (isAdmin) {
      callRequest(setData, filters);
    }
  }, [page]);

  const changePage = (currentPage: number) => {
    setFilters({ ...filters, page: currentPage });
    setPage(currentPage);
  };

  // const searchInputChanged = (value) => {
  //   value = value.replace(/[^a-zA-Z0-9 ]/g, "");
  //   value = value.trim().replace(/\s+/g, " ");
  //   // If the value is empty, skip the search logic
  //   if (!value) {
  //     setInputs({ ...inputs, search: "" });
  //     setFilters({ ...filters, search: "" });
  //     return;
  //   }

  //   setInputs({ ...inputs, search: value });
  //   setFilters({ ...filters, search: value });
  //   if (value) {
  //     clearTimeout(timer);
  //     const newTimer = setTimeout(() => {
  //       callRequest(setData, filters, { ...filters, search: value });
  //       setIsFirstPageLoad(false);
  //       setIsFromSearch(true);
  //     }, 500);

  //     setTimer(newTimer);
  //   }
  // };

  const searchInputChanged = (value) => {
    // Allow only alphanumeric and space characters
    const sanitized = value.replace(/[^a-zA-Z0-9 ]/g, "");

    // Update the input immediately for real-time feedback (preserve spaces while typing)
    setInputs({ ...inputs, search: sanitized });

    // Clear previous debounce timer
    clearTimeout(timer);

    // If input is completely empty or only spaces, clear search filters
    if (!sanitized.trim()) {
      setFilters({ ...filters, search: "" });
      return;
    }

    // Debounce the API call
    const newTimer = setTimeout(() => {
      // Final sanitization before making the search request
      const finalSearch = sanitized.trim().replace(/\s+/g, " ");

      // Update filters and make the API call
      setFilters({ ...filters, search: finalSearch });
      callRequest(setData, filters, { ...filters, search: finalSearch });
      setIsFirstPageLoad(false);
      setIsFromSearch(true);
    }, 500);

    setTimer(newTimer);
  };

  const changeRequestType = (data) => {
    //If the request type is the same as the current one, do nothing
    if (data === filters.requestType) {
      return;
    }
    setIsFromSearch(false);
    let filterPayload = { ...filters, requestType: data, page: 1 };
    setFilters(filterPayload);
    callRequest(setData, filterPayload);
    setPage(1);
  };

  const changeLoanStage = (data) => {
    //If the stage is the same as the current one, do nothing
    if (data === filters.stage) {
      return;
    }
    setIsFromSearch(false);
    let filterPayload = { ...filters, stage: data, page: 1 };
    setFilters(filterPayload);
    callRequest(setData, filterPayload);
    setPage(1);
  };

  const currentDate = new Date().toISOString().substring(0, 10);
  const fileName = "Loans-" + currentDate + ".csv";
  const clearText = () => {
    setData(null);
    searchInputChanged("");
    setFilters(initialFilter);
    setIsFromSearch(true);
    if (isAdmin) {
      setTimeout(() => {
        callRequest(setData, initialFilter);
      }, 500);
    }
  };
  return (
    <>
      <div className="box_container">
        <div className="row g-3">
          <div className="col-md-12">
            <div className="row table-header justify-content-end">
              {hasRole(Roles.credit) && (
                <div className="dropdown margin-end col-12 col-sm-6 col-md-4 col-lg-3 mb-3">
                  <button
                    className="btn bg-gradient-dark mb-0 dropdown-toggle w-100"
                    type="button"
                    disabled={isDropdownDisabled()}
                    onClick={() => exportCreditAPIData(t)}
                    title="Download credit API"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-download"
                      viewBox="0 0 16 16"
                    >
                      <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
                      <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
                    </svg>
                    <span className="mx-1">
                      {t("pages.loans.creditQualityData")}
                    </span>
                  </button>
                </div>
              )}
              <div className="dropdown margin-end col-12 col-sm-6 col-md-4 col-lg-3 mb-3">
                <button
                  className="btn bg-gradient-dark mb-0 dropdown-toggle w-100"
                  data-bs-toggle="dropdown"
                  disabled={isDropdownDisabled()}
                >
                  APP Stage ({t("pages.loans.status." + filters.requestType)})
                </button>
                <ul className="dropdown-menu dropdown-right-align">
                  {loanStages.map((type) => {
                    return (
                      <li key={type}>
                        <a
                          className="dropdown-item"
                          onClick={() => changeRequestType(type)}
                        >
                          {t("pages.loans.status." + type)}
                        </a>
                      </li>
                    );
                  })}
                </ul>
              </div>
              <div className="dropdown margin-end col-12 col-sm-6 col-md-4 col-lg-3 mb-3">
                <button
                  className="btn bg-gradient-dark mb-0 dropdown-toggle w-100"
                  data-bs-toggle="dropdown"
                  disabled={isDropdownDisabled()}
                >
                  Loan Stage ({t("pages.loans.stage." + filters.stage)})
                </button>
                <ul className="dropdown-menu dropdown-right-align">
                  {cashLoanStages.map((stage) => {
                    return (
                      <li key={stage}>
                        <a
                          className="dropdown-item"
                          onClick={() => changeLoanStage(stage)}
                        >
                          {t("pages.loans.stage." + stage)}
                        </a>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>

            <div className="row table-header">
              <div className="col-sm-12 col-md-11 mb-2">
                <div className="input-group search-input align-items-center">
                  <span className="input-group-text">
                    <img alt="" src={Search} />
                  </span>
                  <input
                    type="text"
                    className="form-select"
                    placeholder={t("inputs.loans.searchInputPlaceHolder")}
                    onChange={(e) => searchInputChanged(e.target.value)}
                    value={inputs.search}
                  />
                  {inputs.search && (
                    <button
                      type="button"
                      className="btn-close ps mx-3"
                      aria-label="Close"
                      onClick={clearText}
                    ></button>
                  )}
                </div>
              </div>
              <div className="col-sm-12 col-md-1 mb-2">
                <div
                  className="d-flex align-items-center justify-content-end"
                  role="toolbar"
                  aria-label="Toolbar with button groups"
                >
                  <div
                    className="btn-group"
                    role="group"
                    aria-label="First group"
                  >
                    {/* <button
                      className="btn bg-gradient-dark d-flex-center"
                      type="button"
                      data-bs-toggle="offcanvas"
                      data-bs-target="#offcanvasExample"
                      aria-controls="offcanvasExample"
                      data-bs-placement="top"
                      title="Filter"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                        width="19"
                        height="19"
                      >
                        <path d="M3 4c0-.55.45-1 1-1h16c.55 0 1 .45 1 1 0 .22-.07.42-.2.58L14 13.51v6.75c0 .47-.35.9-.82.98-.58.11-1.15-.29-1.15-.89v-6.84L3.2 4.58A.996.996 0 013 4z" />
                      </svg>
                    </button> */}
                  </div>
                  <div
                    className="btn-group"
                    role="group"
                    aria-label="First group"
                  >
                    <button
                      className="btn bg-gradient-dark d-flex-center"
                      onClick={() => exportData(filters, t)}
                      type="button"
                      title="Download"
                      disabled={isDropdownDisabled()}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="19"
                        height="19"
                        fill="currentColor"
                        className="bi bi-download"
                        viewBox="0 0 16 16"
                      >
                        <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
                        <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-12 ">
            <div className="table-responsive" style={{ minHeight: "25rem" }}>
              <table className="table table-hover my-table">
                {data?.loanLookups.length > 0 && (
                  <thead>
                    <tr>
                      <th scope="col">{t("inputs.loans.createdAt")}</th>
                      <th scope="col">{t("inputs.loans.loanSource")}</th>
                      <th scope="col">{t("inputs.loans.customerName")}</th>
                      <th scope="col">{t("inputs.loans.financialDataId")}</th>
                      <th scope="col">{t("inputs.loans.compAppId")}</th>
                      <th scope="col">{t("inputs.loans.lastCashLoanStage")}</th>
                      <th scope="col">{t("inputs.loans.reason")}</th>
                      <th scope="col">{t("inputs.loans.deviceId")}</th>
                      <th scope="col">
                        {t("inputs.loans.financeTransferStatus")}
                      </th>
                      <th scope="col">
                        {t("inputs.loans.ibanVerificationStatus")}
                      </th>
                      <th scope="col">
                        {t("inputs.loans.creditApprovalStatus")}
                      </th>
                    </tr>
                  </thead>
                )}
                <tbody>
                  {loading && <TableRowPlaceholder />}

                  {data?.loanLookups?.map((item, key) => (
                    <tr key={item.createdAt}>
                      <td style={{ minWidth: 140 }}>
                        <Moment format="YYYY-MM-DD HH:mm:ss" tz="Asia/Riyadh">
                          {item.createdAt}
                        </Moment>
                      </td>
                      <td><b>{item?.loanSource}</b></td>
                      <td>
                        <strong>{item.customerName}</strong>
                        <p className="gray">
                          <strong>{item.nationalId}</strong>
                        </p>
                      </td>
                      <td>{item.financialDataId}</td>
                      <td>{item.compApplId}</td>
                      <td>
                        {t("pages.loans.stage." + item.lastCashLoanStage)}
                      </td>
                      <td>{item?.reason}</td>
                      <td>{item?.deviceId}</td>
                      <td>{item?.financeTransferStatus}</td>
                      <td>
                        {item?.ibanVerificationStatus?.replaceAll("_", " ")}
                      </td>
                      <td>{item?.creditApprovalStatus}</td>
                    </tr>
                  ))}
                  {data?.loanLookups.length <= 0 && (
                    <div className="py-5 my-5 text-center text-muted">
                      No data available
                    </div>
                  )}
                </tbody>
              </table>
            </div>
            {data?.loanLookups.length > 0 && (
              <div className="col-md-12 ">
                <div className="table-footer">
                  <div className="results-count">
                    <p></p>
                  </div>
                  <div className="results-pagination">
                    <nav>
                      <ul className="pagination">
                        <li key={"9991"} className="page-item">
                          <button
                            className="prev page-link"
                            disabled={page <= 1}
                            onClick={() => changePage(page - 1)}
                          >
                            <img alt="" src={Arrow} />
                          </button>
                        </li>
                        {paginationElemnts(
                          data?.loanLookups,
                          page,
                          data?.totalCount,
                          changePage
                        )}
                        <li key={"9992"} className="page-item">
                          <button
                            className="next page-link"
                            disabled={
                              data?.loanLookups?.length < 10 ||
                              page === data?.totalCount / 10
                            }
                            onClick={() => changePage(page + 1)}
                          >
                            <img alt="" src={Arrow} />
                          </button>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div>
            <Accordion activeIndex={0}>
              <AccordionTab header="Stage Descriptions">
                <p className="m-0">
                  <ol>
                    <li>
                      <b>{t("pages.loans.stage.CREATED")} </b>:{" "}
                      <span>{t("pages.loans.stageDescription.CREATED")}</span>
                    </li>
                    <li>
                      <b>{t("pages.loans.stage.LOCKED")} </b>:{" "}
                      <span>{t("pages.loans.stageDescription.LOCKED")}</span>
                    </li>
                    <li>
                      <b>{t("pages.loans.stage.VERIFIED")} </b>:{" "}
                      <span>{t("pages.loans.stageDescription.VERIFIED")}</span>
                    </li>
                    <li>
                      <b>{t("pages.loans.stage.SOFT_REJECTED")} </b>:{" "}
                      <span>
                        {t("pages.loans.stageDescription.SOFT_REJECTED")}
                      </span>
                    </li>
                    <li>
                      <b>{t("pages.loans.stage.COMMODITY_PURCHASED")} </b>:{" "}
                      <span>
                        {t("pages.loans.stageDescription.COMMODITY_PURCHASED")}
                      </span>
                    </li>
                    <li>
                      <b>{t("pages.loans.stage.APP_CUSTCARED")} </b>:{" "}
                      <span>
                        {t("pages.loans.stageDescription.APP_CUSTCARED")}
                      </span>
                    </li>
                    <li>
                      <b>{t("pages.loans.stage.CALL_INITIALIZED")} </b>:{" "}
                      <span>
                        {t("pages.loans.stageDescription.CALL_INITIALIZED")}
                      </span>
                    </li>
                    <li>
                      <b>{t("pages.loans.stage.CALL_APPROVED")} </b>:{" "}
                      <span>
                        {t("pages.loans.stageDescription.CALL_APPROVED")}
                      </span>
                    </li>
                    <li>
                      <b>{t("pages.loans.stage.CONTRACT_SIGNED")} </b>:{" "}
                      <span>
                        {t("pages.loans.stageDescription.CONTRACT_SIGNED")}
                      </span>
                    </li>
                    <li>
                      <b>{t("pages.loans.stage.SANAD_CREATED")} </b>:{" "}
                      <span>
                        {t("pages.loans.stageDescription.SANAD_CREATED")}
                      </span>
                    </li>
                    <li>
                      <b>{t("pages.loans.stage.WAITING_FOR_DISBURSED")} </b>:{" "}
                      <span>
                        {t(
                          "pages.loans.stageDescription.WAITING_FOR_DISBURSED"
                        )}
                      </span>
                    </li>
                    <li>
                      <b>{t("pages.loans.stage.NAFAES_SALES_ORDERED")} </b>:{" "}
                      <span>
                        {t("pages.loans.stageDescription.NAFAES_SALES_ORDERED")}
                      </span>
                    </li>
                    <li>
                      <b>{t("pages.loans.stage.DISBURSED")} </b>:{" "}
                      <span>{t("pages.loans.stageDescription.DISBURSED")}</span>
                    </li>
                    <li>
                      <b>{t("pages.loans.stage.WITHDRAWAL_REQUESTED")} </b>:{" "}
                      <span>
                        {t("pages.loans.stageDescription.WITHDRAWAL_REQUESTED")}
                      </span>
                    </li>
                    <li>
                      <b>{t("pages.loans.stage.WITHDRAWAL_SUCCESS")} </b>:{" "}
                      <span>
                        {t("pages.loans.stageDescription.WITHDRAWAL_SUCCESS")}
                      </span>
                    </li>
                    <li>
                      <b>{t("pages.loans.stage.WITHDRAWAL_FAILED")} </b>:{" "}
                      <span>
                        {t("pages.loans.stageDescription.WITHDRAWAL_FAILED")}
                      </span>
                    </li>
                    <li>
                      <b>{t("pages.loans.stage.HARD_REJECTED")} </b>:{" "}
                      <span>
                        {t("pages.loans.stageDescription.HARD_REJECTED")}
                      </span>
                    </li>
                  </ol>
                </p>
              </AccordionTab>
            </Accordion>
          </div>
        </div>
      </div>
    </>
  );
};
